export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11527.7a145314.jpg";